;
define("product_list_details_min_quantity.tpl", function(){});

